import type { HTMLAttributes } from "react";
import { cn } from "@/shared/lib/utils";
import { cva, type VariantProps } from "@/shared/lib/variants";

/**
 * Section padding shell. Required per design.md §5; new sections MUST use a
 * spacing preset rather than hand-rolling vertical padding.
 */
const section = cva("", {
  variants: {
    spacing: {
      sm: "py-8",
      md: "py-12",
      lg: "py-20",
      marketing: "px-6 py-20 md:px-12 md:py-32 lg:px-24",
    },
  },
  defaultVariants: {
    spacing: "md",
  },
});

export interface SectionProps
  extends HTMLAttributes<HTMLElement>,
    VariantProps<typeof section> {}

export function Section({ spacing, className, ...props }: SectionProps) {
  return <section className={cn(section({ spacing }), className)} {...props} />;
}
